module.exports = __webpack_public_path__ + "static/media/red-arrow.8ad71867.svg";